module.exports = __webpack_public_path__ + "static/media/introduksjon-Ordforstaelse.ba88920a.mp3";